module.exports = __webpack_public_path__ + "fonts/ProximaNova-Semibold.a55c8a73.ttf";